<style src="./base.css" scoped></style>
<style src="./listingTables.css" scoped></style>
<style src="./elements.css" scoped></style>
<style>@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,800;1,800&display=swap');</style>

<template>
  <div class="project-list-container">
    <!-- Page Title -->
    <h1 class="page-title">Active projects</h1>

    <!-- Place this near your admin tools or project controls -->
    <!-- <button @click="backfillSearchData">🧹 Backfill Search Data</button>-->

    <!-- Actions Row -->
      <div class="actions">
        <div class="search-container">
          <input
            type="text"
            v-model="searchTerm"
            placeholder="Search by project name or keyword..."
            class="search-input"
          />
        </div>
      <!-- Toggle between Active and Retired projects -->
      <button class="retired-projects-btn" @click="toggleProjectFilter">
        {{ projectFilter === 'active' ? 'Show Retired projects' : 'Show Active projects' }}
      </button>
      <!-- Add Project Button -->
      <button class="action-button" @click="openAddProjectModal">
        Add Project
      </button>

      <!-- Add Project Modal -->
      <div v-if="showAddProjectModal" class="modal-overlay">
    <div class="modal-content">
      <h2>Create New Project</h2>

      <!-- Project Name -->
      <div class="team-select">
        <label>Project Name</label><p>Copy/paste the Project Name from Teamwork</p>
      <input v-model="newProjectName" placeholder="Project Name" required/>
      </div>

    <!-- ▼ Assigned Designers (multi‑select + Add) -->
    <div class="team-select">
    <label>Assign Team</label><p>Select at least 2 members: a PAM and a Designer</p>
      <div class="flex">
        <select v-model="selectedDesigner" required>
          <option disabled value="">Select a user…</option>
          <option
            v-for="u in assignableUsers"
            :key="u.id"
            :value="u.id"
          >{{ u.fullName }} ({{ u.role }})</option>
        </select>
        <button class="text-button-large" @click="addDesigner">Add</button>
      </div>
      <ul>
        <div class="added-team-list">
          <li v-for="(id, index) in selectedDesigners" :key="id" class="added-team-item">
            {{ assignableUsers.find(u => u.id === id)?.fullName || id }}
            <button type="button" class="text-button" @click="removeDesigner(index)">Remove</button>
          </li>
        </div>
      </ul>
    </div>

      <!-- Leading Producer: only those with role === "production" -->
    <div class="team-select">
      <label>Leading Producer</label><p>Select your main Producer. Later, you can add additional producers on the project page in Team</p>
      <select v-model="selectedLeadingProducer" required>
        <option disabled value="">Select leading producer…</option>
        <option
          v-for="u in onlyProducers"
          :key="u.id"
          :value="u.id"
        >{{ u.fullName }}</option>
      </select>
    </div>
      
      <!-- Create / Cancel -->
      <button class="action-button" @click="createProject" :disabled="!isFormValid">Create</button>
      <button class="text-button-large" @click="closeAddProjectModal">Cancel</button>
    </div>
  </div>
    </div>

    <!-- Table of Projects -->
    <table class="project-table">
      <thead>
        <tr>
          <!-- New Score Column -->
          <th class="score-col">HEALTH</th>
          <th>PROJECT NAME</th>
          <th>PRODUCER</th>
          <th>CREATED BY</th>
          <th>CREATED ON</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(project, index) in filteredProjects" :key="index">
          <!-- Score cell with dynamic color -->
          <td class="score-col" :style="{ color: getScoreColor(project.totalFeedbackScore) }">
            {{ project.totalFeedbackScore }}
          </td>
          <td>
            <router-link :to="`/feedback/${project.id}/dashboard`" class="project-link">
              {{ project.projectName || "Project Title" }}
            </router-link>
          </td>
          <td>
            <span v-if="project.producers && project.producers.length">
              {{ project.producers.join(", ") }}
            </span>
            <span v-else></span>
          </td>
          <td>{{ project.submittedBy || "Unknown" }}</td>
          <td>{{ formatDate(project.createdAt) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Error Message -->
    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script>
import ProjectListLogic from "./ProjectListLogic.js";

export default {
  name: "ProjectList",
  mixins: [ProjectListLogic],
  methods: {
    // Convert Firestore Timestamp to a readable string
    formatDate(timestamp) {
      if (!timestamp) return "";
      const dateObj = new Date(timestamp.seconds * 1000);
      return dateObj.toLocaleString();
    },
    // Return a color for the project score based on its value
    getScoreColor(score) {
      if (score <= 60) {
        return "#c1312f";
      } else if (score <= 75) {
        return "#ea8459";
      } else if (score <= 85) {
        return "#e9cb1c";
      } else {
        return "#099034";
      }
    }
  }
};
</script>

<style scoped>
.project-list-container {
  margin: 0 auto;
  padding: 1rem;
}

.score-col {
  width: 80px;
  font-weight: bold;
  text-align: center;
}

/* Modal overlay styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modal content styles */
.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 35px;
  max-width: 500px;
  min-width: 350px;
  width: 90%;
}

.modal-content h2 {
  margin-bottom: 1.5rem;
  color: #111827;
}

.team-select label:after{
  content: '*';
  color: red
}

.form-control:focus + .team-select label{ 
  display: none;
}

.modal-content p {
  margin-top: 5px;
  font-size: 0.7rem;
  color: #82868d;
}

/* Modal input */
.team-select input,
.team-select select {
    width: 80%;
    padding: 10px;
    border: 1px solid #C9BF9B;
    border-radius: 9px;
    font-size: 1rem;
    color: #111827;
    background-color: #F8F7F3;
    margin-top: 15px;
    margin-bottom: 10px;
}

.added-team-list {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
.added-team-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem;
    background-color: #f8f7f3;
    border-radius: 6px;
    margin-bottom: 0.5rem;
    color: #EA845A;
    padding-left: 0.7rem;
    font-size: 0.85rem;
  }

.team-select {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modal action buttons */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.team-select label {
  font-weight: bold;
  margin-bottom: -5px;
  color: #111827;
}

.cancel-button {
  width: 24%;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    background-color: #fff;
    border: 1px solid #C9BF9B;
    border-radius: 15px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}
.cancel-button:hover {
  background-color: #C9BF9B;
  }

</style>
